/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Onboarding_Usage_HintInputs */



/**
* | output |
* | --- |
* | "Pick up to {max}" |
*
* @param {Onboarding_Usage_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_hint = /** @type {((inputs: Onboarding_Usage_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wähle bis zu ${i?.max}`)
	return /** @type {LocalizedString} */ (`Pick up to ${i?.max}`)
});